import { memo, type ReactNode } from 'react'

import { Skeleton } from '@/components/ui/skeleton'
import { TableHead, TableHeader, TableRow } from '@/components/ui/table'

interface DataTableSkeletonHeaderProps {
  columnIdList: string[]
  hasCheckbox: boolean
  hasActions: boolean
}

/**
 * Renders the skeleton header row for the data table loading state.
 */
const DataTableSkeletonHeaderBase: React.FC<DataTableSkeletonHeaderProps> = ({
  columnIdList,
  hasCheckbox,
  hasActions,
}): ReactNode => (
  <TableHeader>
    <TableRow>
      {hasCheckbox && (
        <TableHead className="w-[40px]">
          <Skeleton className="size-4" />
        </TableHead>
      )}
      {columnIdList.map((id) => (
        <TableHead key={id}>
          <Skeleton className="h-4 w-[80px]" />
        </TableHead>
      ))}
      {hasActions && <TableHead className="w-[60px]" />}
    </TableRow>
  </TableHeader>
)

export const DataTableSkeletonHeader = memo(DataTableSkeletonHeaderBase)

DataTableSkeletonHeader.displayName = 'DataTableSkeletonHeader'
